/**
 * Bollinger Bands Quantum — wiring del indicador.
 *
 * Cálculo 100% cliente (engine.js sobre las velas del chart); pintura 100%
 * canvas vía series nativas de lightweight-charts (renderer.js). Sin backend.
 * Reemplazo Quantum del indicador legacy `bollinger` (la migración v9 de
 * useIndicatorState mapea su toggle a este id).
 */

import BadgeComponent from './Badge.jsx'
import PanelComponent from './Panel.jsx'
import { SAFE_DEFAULTS, resolveConfig } from './constants.js'
import { compute } from './engine.js'
import { renderBollinger } from './renderer.js'

export const defaultConfig = SAFE_DEFAULTS

export { resolveConfig }

export function detect(candles, config) {
  const cfg = resolveConfig(config)
  if (cfg.enabled === false) return compute([], cfg)
  return compute(Array.isArray(candles) ? candles : [], cfg)
}

export function render(chart, candleSeries, result, config, api) {
  renderBollinger(chart, candleSeries, result, config, api)
}

export default {
  id: 'bollinger_bands_quantum',
  name: 'Bollinger Bands Quantum',
  version: '1.0.0',
  // Las line series y custom series de LWC panean solas; nada del dibujo
  // depende del viewport. Opt-out del repintado por panTick (anti-flicker).
  renderOnPan: false,
  defaultConfig,
  detect,
  render,
  BadgeComponent,
  PanelComponent,
}
